import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../_services';
import * as uuid from 'uuid';
import { User } from '../_models';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

	loginForm: UntypedFormGroup;
	loading = false;
	submitted = false;
	returnUrl: string;
	error = '';
	admin: boolean;
	fingerprint = uuid.v4();
	id: string;
	hide = true;


	constructor(
		private formBuilder: UntypedFormBuilder,
		private route: ActivatedRoute,
		private router: Router,
		private authenticationService: AuthenticationService,
		public dialog: MatDialog,
	) {

	}

	ngOnInit() {
		this.id = this.router.url.replace(/\D+/g, "");

		this.loginForm = this.formBuilder.group({
			username: ['', Validators.required],
			password: ['', Validators.required]
		});

		if (this.authenticationService.isLoggedIn()) {
			this.router.navigate(['/home']);
			return;
		}
		// reset login status
		this.authenticationService.logout();

		// get return url from route parameters or default to '/'
		this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
	}

	// convenience getter for easy access to form fields
	get f() { return this.loginForm.controls; }

	onSubmit() {
		this.submitted = true;

		// stop here if form is invalid
		if (this.loginForm.invalid) {
			return;
		}

		this.loading = true;
		this.authenticationService.login(this.f.username.value, this.f.password.value, this.fingerprint, this.admin)
			.subscribe(
				user => {
					if (this.id) {
						this.router.navigate(['/gestao/conteudo/editar/' + this.id + '/arquivos']);
					} else {
						this.authenticationService.getLastUrl().subscribe(res => {
							if(res.url){
								this.router.navigate([res.url])
							}else{
								this.router.navigate(['/home']);
							}
						},
						error => {
							if(error.status === 404){
								this.router.navigate(['/home']);
							}
						})
					}
				},
				error => {
					if (error.status === 401 && error.message === 'Authentication Failed: Unexpected error! Contact the Administrator.') {
						this.error = 'Erro inesperado! Contate o Administrador';
					} else if (error.status === 401 && error.message === 'Authentication Failed: Attempts login exceeded') {
						this.error = 'Tentativas de login excedida';
					} else {
						this.error = 'Usuário e/ou senha incorretos';
					}

					this.loading = false;
				});
	}

	forgotPassword() {
		const dialogRef = this.dialog.open(ForgotPasswordComponent, {
			width: '620px',
			disableClose: true
		})

		dialogRef.afterClosed().subscribe(res => {
		});
	}
}
